// <script async src="https://...?lang=ru_RU&load=&onload=_onYandexMapLoaded"></script>
// or use module aload instead of async attribute (github.com/pazguille/aload)

const ymapsFunctionsStack = [];

// random postfix to get uniq function name
window._onYandexMapLoaded = function _onYandexMapLoaded() {
  while (ymapsFunctionsStack.length) {
    ymapsFunctionsStack.pop()();
  }
};

module.exports = function ymapsRequire(dependencies, callback) {
  if (window.ymaps) {
    window.ymaps.modules.require(dependencies, callback);
  } else {
    ymapsFunctionsStack.push(() => {
      window.ymaps.modules.require(dependencies, callback);
    });
  }
};


// Usage example:
// ymapsRequire(['Map', 'Placemark'], (Map, Placemark) => {
//   console.log('loaded', Map, Placemark)
// })



// WEBPACK FOOTER //
// ./src/serp/helpers/ymaps-reqiure.js